import { useEffect, useState } from "react";
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Link, Typography } from "@mui/material";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";

import { BaseAPI } from "../utils/Api";
import { getItem, setItem } from "../utils/Helper";
import Notification from "../utils/Notification";
import ErrorHandler from "../utils/ErrorHandler";

import LoadingState from "../components/Controls/LoadingState";
import EmptyState from "../components/Controls/EmptyState";
import colabImg from "../assets/images/colab.png";

const PurchasedDataset = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [purchasedDatasetList, setPurchasedDatasetList] = useState([]);

  useEffect(() => {
    const code = window.location.search?.split("=")[1];

    if (code !== undefined) {
      console.log("ami ekhane");
      setLoading(true);
      BaseAPI.post("/dataset/colab/push", { url_name: getItem(localStorage, "dl"), code }, { headers: { Authorization: `Bearer ${getItem(localStorage, "at")}` } })
        .then((res) => {
          window.location.href = res.data.data.colab;
          return null;
        })
        .catch((err) => {
          Notification(err?.response?.data?.message, "error");
        })
        .finally(() => setLoading(false));
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    BaseAPI.get("/dataset/purchased", { headers: { Authorization: `Bearer ${getItem(localStorage, "at")}` } })
      .then((res) => {
        setPurchasedDatasetList(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err.response.data.message, navigate);
        } else {
          Notification("Something went wrong! Please try again", "error");
        }
      })
      .finally(() => setLoading(false));

    return () => {
      setPurchasedDatasetList([]);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadDataset = (value) => {
    setLoading(true);
    BaseAPI.post("/dataset/download", { url_name: value }, { headers: { Authorization: `Bearer ${getItem(localStorage, "at")}` } })
      .then((res) => {
        const blob = new Blob([base64ToArrayBuffer(res.data.data.base64)]);
        FileSaver.saveAs(blob, `${value}.xlsx`);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err.response.data.message, navigate);
        } else {
          Notification("Something went wrong! Please try again", "error");
        }
      })
      .finally(() => setLoading(false));
  };

  const base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  };

  return (
    <>
      {loading ? (
        <LoadingState loading={loading} />
      ) : purchasedDatasetList?.length > 0 ? (
        <>
          <Typography variant='h4' mt={2} mb={4} className='bold'>
            Purchased Datasets
          </Typography>

          <Grid container spacing={3}>
            {purchasedDatasetList?.map((el, i) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                <Card elevation={0}>
                  <CardMedia component='img' alt='item card' height='180' image={`${process.env.REACT_APP_s3_cdn}/${process.env.REACT_APP_STAGE}/cover_images/${el.image}`} />
                  <CardContent sx={{ height: "140px" }}>
                    <Typography variant='body2'>{el.category} </Typography>
                    <Typography variant='subtitle1'>
                      {el.name} ({el.data_rows} Rows)
                    </Typography>
                    <Typography variant='subtitle2'>Last Updated: {el.last_updated} </Typography>
                  </CardContent>
                  <CardActions>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Button fullWidth variant='contained' color='primary' disableElevation startIcon={<ArrowDownwardRoundedIcon />} onClick={() => downloadDataset(el.url_name)}>
                          Download Dataset
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant='text'
                          color='secondary'
                          disableElevation
                          startIcon={<img src={colabImg} alt='open with colab' height='30' width='30' />}
                          onClick={() => setItem(localStorage, "dl", el.url_name)}
                          component={Link}
                          target='_blank'
                          rel='noopener noreferrer'
                          href={`${process.env.REACT_APP_data_lagbe}/dataset/colab/token`}>
                          Open With Colab
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <EmptyState message="You haven't purchased any dataset yet ☹" />
      )}
    </>
  );
};

export default PurchasedDataset;
